import { render, staticRenderFns } from "./FittingsAnalysis.vue?vue&type=template&id=281e5e6e&scoped=true"
import script from "./FittingsAnalysis.vue?vue&type=script&lang=js"
export * from "./FittingsAnalysis.vue?vue&type=script&lang=js"
import style0 from "./FittingsAnalysis.vue?vue&type=style&index=0&id=281e5e6e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e5e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('281e5e6e')) {
      api.createRecord('281e5e6e', component.options)
    } else {
      api.reload('281e5e6e', component.options)
    }
    module.hot.accept("./FittingsAnalysis.vue?vue&type=template&id=281e5e6e&scoped=true", function () {
      api.rerender('281e5e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsAnalysis/FittingsAnalysis.vue"
export default component.exports